module.exports = __webpack_public_path__ + "right-arrow.png?ad39b85e5f6a753138d2eedd81fab484";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right-arrow.png
// module id = 1004
// module chunks = 2